<div *ngFor="let a of attachments" class="me-2" style="display: inline-block">
  <div class="d-flex align-items-center">
    <i class="emp-ico icon-ico_attachment me-1"></i>
    <span class="attachment-name"><ey-text-expander [charLimit]="30" [splitText]="false" [text]="a"></ey-text-expander></span>
  </div>
</div>
